module.exports = __webpack_public_path__ + "img/ساده.21e80bfe.png";